export function converterParaNumeroAmericano(valorBrasileiro: string): number {
  if (!valorBrasileiro) return 0;
  const semPontoMilhar = valorBrasileiro.replace(/\./g, '');
  const numeroAmericano = semPontoMilhar.replace(',', '.');
  const parsed = parseFloat(numeroAmericano);
  return isNaN(parsed) ? 0 : parsed;
}

export function converterParaNumeroBrasileiro(valorAmericano: number): string {
  if (!valorAmericano || isNaN(valorAmericano)) return '0,00';
  const valorString = valorAmericano.toFixed(2);
  const [parteInteira, parteDecimal] = valorString.split('.');
  const comSeparadorMilhar = parteInteira.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${comSeparadorMilhar},${parteDecimal}`;
}
